import script from "./FundOptionsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FundOptionsCard.vue?vue&type=script&setup=true&lang=js"

import "./FundOptionsCard.vue?vue&type=style&index=0&id=0d300ec5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d300ec5"]])

export default __exports__